import { createSlice } from "@reduxjs/toolkit";

import { fetchPipelineValueByCustomer } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load pipeline value by customer";

const pipelineValueByCustomerSlice = createSlice({
  name: "pipelineValueByCustomer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPipelineValueByCustomer.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPipelineValueByCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchPipelineValueByCustomer.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default pipelineValueByCustomerSlice.reducer;
